import { combineReducers } from 'redux'

import { IJackpotsState } from '../types'
import communications from './communications'
import data from './data'

export const reducer = combineReducers<IJackpotsState>({
  communications,
  data,
})
